<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="100px" class="EL-Form">


                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.verdorCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5" v-if="ChangeRecordSearch.fcCode">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.batchNo" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                

               <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select  v-model="ChangeRecordSearch.status" clearable="clearable">
                          <el-option key="" value="" label="全部"></el-option>
                          <el-option key="10" value="10" label="待出库"></el-option>
                            <el-option key="20" value="20" label="完成出库"></el-option>

                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>-->

                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="日期范围" class="EL-Form-Item">
                        <el-date-picker style="width: 280px" v-model="ChangeRecordSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="ChangeRecordSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="ChangeRecordSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
              <el-col :lg="4" :xl="4">
                <el-form-item class="btn-edit-delete EL-Form-Item">
                  <el-button class="btn-t-edit" @click="clickSelectList()">
                    查询
                  </el-button>
                  <el-button class="btn-t-delete" @click="ChangeRecordReset()">
                    重置
                  </el-button>
                </el-form-item>
              </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="托盘管理">
              <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="returnWhInventoryPalle('10')">破损</el-button>
              <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="returnWhInventoryPalle('20')">结算</el-button>
              <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="returnWhInventoryPalle('30')">退货</el-button>
              <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="returnWhInventoryPalle('40')">置换</el-button>
                <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="insertOpenRecord()">出库记录</el-button>
                <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="ChangeRecordData.headerCellStyle" style="height: 77vh" @pageChange="getStatusTransitionRecordList" :data="ChangeRecordData.data" pagination :nowPage.sync="ChangeRecordData.pageNum" :pageSize.sync="ChangeRecordData.pageSize" :total.sync="ChangeRecordData.total" @selectionChange="selectAllChangeRecord">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="供应商" prop="verdorCode" align="center">
                </el-table-column>
                <el-table-column label="供应商名称" prop="svName" align="center">
                </el-table-column>


                <el-table-column label="LIDS数量" prop="lidsNumber" align="center" width="150px">
                </el-table-column>
                <el-table-column label="LIDS出库数量" align="center" prop="lidsNumberOut">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.lidsNumberOut"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                  </template>
                </el-table-column>
              <el-table-column label="COLLARS数量" prop="collarsNumber" align="center" width="150px">
              </el-table-column>
              <el-table-column label="COLLARS出库数量" align="center" prop="collarsNumberOut">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.collarsNumberOut"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="BASES数量" prop="basesNumber" align="center" width="150px">
              </el-table-column>
              <el-table-column label="BASES出库数量" align="center" prop="basesNumberOut">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.basesNumberOut"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </template>
              </el-table-column>
              <!--
                <el-table-column label="状态" prop="oldStatus" align="center" width="105px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '10'">待出库</span>
                        <span v-if="scope.row.status == '20'">已出库</span>

                    </template>
                </el-table-column>-->


              <el-table-column label="是否收费" prop="palletFlag" align="center" width="180px">
                <template slot-scope="scope">
                  <span v-if="scope.row.palletFlag == '1'">否</span>
                  <span v-if="scope.row.palletFlag != '1'">是</span>
                </template>
              </el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center" width="180px">
                </el-table-column>
              <el-table-column label="修改时间" prop="updateTime" align="center" width="180px">
              </el-table-column>
              <!--<el-table-column label="出库时间" prop="returnTime" align="center" width="180px">
             </el-table-column>

             <el-table-column label="操作人" prop="person" align="center">
             </el-table-column>-->
            </h-table>

          <el-dialog title="出库记录" :visible.sync="mainSearcRecord.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="80px" class="EL-Form">






              <el-col :lg="5" :xl="5">
                <el-form-item label="供应商" class="EL-Form-Item">
                  <el-input v-model="mainSearcRecord.query.verdorCode" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="开始日期" class="EL-Form-Item">
                  <el-date-picker v-model="mainSearcRecord.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="结束日期" class="EL-Form-Item">
                  <el-date-picker v-model="mainSearcRecord.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :xl="6">
                <el-form-item class="btn-edit-delete EL-Form-Item">
                  <el-button class="btn-t-edit" @click="getOtherRecordList()">查询</el-button>
                  <el-button v-authority="'BACK_MENU3_M23_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFileRecordList">导出EXCEL</el-button>
                </el-form-item>
              </el-col>
            </el-form>

            <h-table :headerCellStyle="mainSearcRecord.headerCellStyle" :style="$popups.harvestRecordStyle(0.60)" @pageChange="getOtherRecordList()" :data="mainSearcRecord.data" pagination :nowPage.sync="mainSearcRecord.pageNum" :pageSize.sync="mainSearcRecord.pageSize" :total.sync="mainSearcRecord.total"  @selectionChange="selectAllPrintLists">
              <el-table-column type="selection" align="center"> </el-table-column>

              <el-table-column label="供应商" align="center" prop="verdorCode">
              </el-table-column>
              <el-table-column label="供应商名称" align="center" prop="svName">
              </el-table-column>
              <el-table-column label="LIDS数量" align="center" prop="lidsNumber">
              </el-table-column>

              <el-table-column label="COLLARS数量" align="center" prop="collarsNumber">
              </el-table-column>
              <!-- <el-table-column label="入库库区" align="center" prop="whArea">
              </el-table-column> -->

              <el-table-column label="BASES数量" align="center" prop="basesNumber">
              </el-table-column>
              <el-table-column label="是否收费" prop="palletFlag" align="center" width="180px">
                <template slot-scope="scope">
                  <span v-if="scope.row.palletFlag == '1'">否</span>
                  <span v-if="scope.row.palletFlag != '1'">是</span>
                </template>
              </el-table-column>
              <el-table-column label="出库类型" prop="palletFlag" align="center" width="180px">
                <template slot-scope="scope">
                  <span v-if="scope.row.returnType == '10'">破损</span>
                  <span v-if="scope.row.returnType == '20'">结算</span>
                  <span v-if="scope.row.returnType == '30'">退货</span>
                  <span v-if="scope.row.returnType == '40'">置换</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="createTime">
              </el-table-column>

              <el-table-column label="操作人" align="center" prop="person">
              </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
              <el-button size="mini" @click="mainSearcRecord.insertShowRecord = false" type="info">关闭</el-button>
            </div>
          </el-dialog>

        </box>
    </div>
</template>

<script>
    export default {
        name: "StatusTransitionRecord",
        data() {
            return {
                ChangeRecordData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
              mainSearcRecord: {
                query: {
                  fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                  //whCode: localStorage.getItem("whCode") || "", // 通道编号
                  sorType: "20",
                  verdorCode: "", //业务类型
                  date: [],
                  sqResult:"",
                },
                pageNum: 1,
                pageSize: 50,
                total: 0,
                data: [],
                insertShowRecord: false,
                headerCellStyle: () => {
                  return "background-color: #1f6cec";
                },
              },
                ChangeRecordSearch: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    matCode: "",
                    verdorCode: "",
                    status: "",
                    batchNo: "",
                    laCode: "",
                    boxBarcode: "",
                    date: [],
                },

                downloadLoading: false, //下载中

                //多选状态数组
                sckStatusList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
                checkList:[],
            };
        },
        watch: {
            ChangeRecordSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            sckStatusList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.ChangeRecordSearch.date[0]) {
                            return time.getTime() < new Date(_this.ChangeRecordSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.ChangeRecordSearch.date[1]) {
                            return time.getTime() > new Date(_this.ChangeRecordSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.ChangeRecordData.pageNum = 1;
                this.getStatusTransitionRecordList(newVal);
            },

            getStatusTransitionRecordList: function() {
                //let status = "";
                this.sckStatusList.forEach((item) => {
                    status += item + ","
                })
                this.$http
                    .request({
                        url: "/api/whInventoryPalle/getWhInventoryPalleManage",
                        method: "GET",
                        params: {
                            verdorCode: this.ChangeRecordSearch.verdorCode || null,
                            beginTime: this.ChangeRecordSearch.date ?
                                this.ChangeRecordSearch.date[0] : null,
                            endTime: this.ChangeRecordSearch.date ?
                                this.ChangeRecordSearch.date[1] : null,
                            pageNum: this.ChangeRecordData.pageNum,
                            pageSize: this.ChangeRecordData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.ChangeRecordData.data = resp.data.list || [];
                            this.ChangeRecordData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 多选
             */
            selectAllChangeRecord(val) {
              this.checkList = val;
            },
            //清空
            ChangeRecordReset() {
                this.ChangeRecordSearch = {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    matCode: "",
                    matName: "",
                    status: "",
                    batchNo: "",
                    laCode: "",
                    boxBarcode: "",
                    date: [],
                };
                this.getStatusTransitionRecordList();
            },
          returnWhInventoryPalle(returnType) {
            if(this.checkList.length == 0){
              this.$message({
                message: "请选择记录",
                type: "warning",
              });
              return;
            }
            if(this.checkList.length > 1){
              this.$message({
                message: "请选择一条记录",
                type: "warning",
              });
              return;
            }


            this.$http.request({
              url: '/api/whInventoryPalle/returnWhInventoryPalle',
              method: 'POST',
              params: {
                verdorCode:this.checkList[0].verdorCode,
                lidsNumberOut:this.checkList[0].lidsNumberOut,
                collarsNumberOut:this.checkList[0].collarsNumberOut,
                basesNumberOut:this.checkList[0].basesNumberOut,
                person: localStorage.getItem("user"),
                returnType:returnType,

              }
            }).then((resp) => {
              if(resp.status == 100){
                this.$notify({
                  message: "操作成功!",
                  type: "success",
                });
                this.logRemarks = "wh_inventory：出库成功";
                this.systemLog();
                this.clickSelectList();
              } else{
                this.$notify.error({
                  message: '操作失败'
                });
              }
            })
          },
          /* 出库记录弹出框 */
          insertOpenRecord() {
            this.mainSearcRecord.insertShowRecord = true;
            this.getOtherRecordList();
          },
          /* 查询记录数据 */
          getOtherRecordList() {
            this.$http
                .request({
                  url: "/api/whInventoryPalle/getWhInventoryPalleRecord",
                  method: "GET",
                  params: {
                    pageNum: this.mainSearcRecord.pageNum, // 页号
                    pageSize: this.mainSearcRecord.pageSize, // 页大小
                    verdorCode: this.mainSearcRecord.query.verdorCode || null, //物料编号
                    person: this.mainSearcRecord.query.person || null, //操作人
                    beginTime: this.mainSearcRecord.query.date ?
                        this.mainSearcRecord.query.date[0] : null,
                    endTime: this.mainSearcRecord.query.date ?
                        this.mainSearcRecord.query.date[1] : null,
                  },
                })
                .then((res) => {
                  if (res.status == 100) {
                    this.mainSearcRecord.data = res.data.list;
                    this.mainSearcRecord.total = res.data.total;
                  } else {
                    this.$message.error("错误");
                  }
                })
                .catch((error) => {
                  this.$message.error("错误");
                });
          },

          /* 查询记录数据 */
          downLoadFileRecordList() {
            this.$http
                .request({
                  url: "/api/whInventoryPalle/getWhInventoryPalleRecord",
                  method: "GET",
                  params: {
                    pageNum: 1, // 页号
                    pageSize: 999999, // 页大小
                    verdorCode: this.mainSearcRecord.query.verdorCode || null, //物料编号
                    person: this.mainSearcRecord.query.person || null, //操作人
                    beginTime: this.mainSearcRecord.query.date ?
                        this.mainSearcRecord.query.date[0] : null,
                    endTime: this.mainSearcRecord.query.date ?
                        this.mainSearcRecord.query.date[1] : null,
                  },
                })
                .then((res) => {
                  res.status == 100 ? this.downLoad(res.data.list || []) : this.$notify.error({
                    message: '查询失败'
                  });
                })
                .catch((error) => {
                  this.$message.error("错误");
                });
          },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                  verdorCode: this.ChangeRecordSearch.verdorCode || null,
                  //status: this.ChangeRecordSearch.status || null,
                  status: this.ChangeRecordSearch.status || null,
                  batchNo: this.ChangeRecordSearch.batchNo || null,
                  laCode: this.ChangeRecordSearch.laCode || null,
                  beginTime: this.ChangeRecordSearch.date ?
                      this.ChangeRecordSearch.date[0] : null,
                  endTime: this.ChangeRecordSearch.date ?
                      this.ChangeRecordSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/whInventoryPalle/getWhInventoryPalleManage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.status == '10') {
                            c['status'] = '待出库'
                        } else if (c.status == '20') {
                            c['status'] = '完成出库'
                        // } else if (c.status == 'OVERTIME') {
                        //     c['status'] = '过期'
                        // } else if (c.status == 'DELETE') {
                        //     c['status'] = '作废'
                        }

                      if (c.palletFlag == '1') {
                        c['palletFlag'] = '否'
                      } else {
                        c['palletFlag'] = '是'

                      }
                      if (c.returnType == '10') {
                        c['returnType'] = '破损'
                      } else if(c.returnType == '20'){
                        c['returnType'] = '结算'

                      }else if(c.returnType == '30'){
                        c['returnType'] = '退货'

                      }else if(c.returnType == '40'){
                        c['returnType'] = '置换'

                      }
                    })
                    const tHeader = [ '供应商','供应商名称','LIDS数量',  'COLLARS数量','BASES数量','是否收费','出库类型',
                        '创建时间'
                    ]
                    const filterVal = ['verdorCode','svName','lidsNumber',   'collarsNumber','basesNumber','palletFlag','returnType',
                        'createTime'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '托盘管理记录单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出托盘管理"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "托盘管理",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getStatusTransitionRecordList();
        },
    };
</script>

<style scoped>
</style>